// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1PB6p","containerItemsCenter":"Skeleton_containerItemsCenter__23DpT"};